import { Component } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { ChargersService } from '../../../chargers/services/chargers.service';

@Component({
  selector: 'xos-clear-filter-chargers',
  templateUrl: './clear-filter-chargers.component.html',
  styleUrls: ['./clear-filter-chargers.component.scss'],
})
export class ClearFilterChargersComponent extends Toast {
  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, private chargersService: ChargersService) {
    super(toastrService, toastPackage);
  }

  clearFilter(): void {
    this.chargersService.resetFilterMode();
  }

  close(): void {
    this.toastrService.clear();
  }
}
